import { Controller } from "@commoncore/controller/Controller";
import { UserloginController } from "@commoncore/controller/UserLoginController";
import { AppEvents } from "@commoncore/utils/app-events";
import { FileOperationsImplementation } from "projects/common-repo/src/app/core/implementation/FileOperationsImplementation";
import { ENV_CONSTANTS } from "properties/environment";
import { ENV_CONFIG } from "properties/environment-config";
import { AnyCatcher } from "rxjs/internal/AnyCatcher";
import { GlobalClassInstance } from "../../../../../common-repo/src/app/core/constants/GlobalClass";
import { PeoplesTabImplementation } from "../../../../../common-repo/src/app/core/implementation/PeoplesTabImplementation";
import { GlobalService } from "../../../../../common-repo/src/app/core/services/global.service";
import { ProfileImplementation } from "../implementation/ProfileImplementation";

export class PeoplesTabController extends Controller{
  public static singleInstance:any = null;
  peoplesTabImplementation: PeoplesTabImplementation;
  universalService: any;
  listService:any;
  public fileOperationsImplementation:any;
  lazyLoadImgService:any;
  ProfileImplementation:ProfileImplementation;
  userController:any;
  userImplRef:any;

  public constructor(private globalService:GlobalService) {
    super(globalService);
    this.peoplesTabImplementation= PeoplesTabImplementation.getInstance(globalService);
    this.fileOperationsImplementation = FileOperationsImplementation.getInstance(this.globalService)
    this.ProfileImplementation= ProfileImplementation.getInstance(globalService);
    this.userController=UserloginController.getInstance(this.globalService);
    this.userImplRef = this.userController.userLoginImplementation;
    this.setEnvObjects(globalService);
  }

  public static getInstance(connectionService):PeoplesTabController{
		if(this.singleInstance == null){
			this.singleInstance = new PeoplesTabController(connectionService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.lazyLoadImgService = globalService.getLazyLoadImgServiceRef();
    if(this.universalService.virtualGridEnabled){
      this.lazyLoadImgService = globalService.getVirtualLazyLoadImgServiceRef();
    }
  }

  async getAllDetectedPeoplesFaces(){
    this.peoplesTabImplementation.setHandler(this.globalService);
    let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] //* ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["fgpURL"] + ENV_CONFIG.commonUrls["faceGrouping"] + ENV_CONFIG.commonUrls["faces"] + "?limit=" + limit;
    try{
      var result = await this.peoplesTabImplementation.getAllDetectedPeoplesFaces(url);
      return result
    }catch(exc){
      console.log("exception in fetching all people details",exc);
      return null
    }
    
  }

  //Get all faces on Thank you modal - using different method as existing one changes photos of details as same variable data gets set
  async getAllPeoplesFacesForSuggestion(lim,val){
    this.peoplesTabImplementation.setHandler(this.globalService);
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["fgpURL"] + ENV_CONFIG.commonUrls["faceGrouping"] + ENV_CONFIG.commonUrls["faces"] + "?limit=2000&suggestions=1";
    try{
      var result = await this.peoplesTabImplementation.getAllPeoplesFacesForSuggestion(url);
      return result
    }catch(exc){
      console.log("exception in fetching all people details",exc);
      return null
    }
    
  }
  

  onScrollDown(docheignt,toppos){
    let self = this;
    if(!this.universalService.virtualGridEnabled){
      this.lazyLoadImgService = this.globalService.getLazyLoadImgServiceRef();
      self.lazyLoadImgService.isScrollingStopped();
    }
    var url = "";
    url = self.peoplesTabImplementation.peopleNextLink;
    try{
      self.peoplesTabImplementation.createUrlForNextLink(docheignt,toppos,url);
      self.peoplesTabImplementation.setHeight();
    }
    catch(exc){
      console.log("exception in scroll down",exc);
    }
  }

  async getAllPhotosOfSelectedPerson(faceKey,sortType){
    this.peoplesTabImplementation.setHandler(this.globalService);
    let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["fgpURL"] + ENV_CONFIG.commonUrls["faceGrouping"] + ENV_CONFIG.commonUrls["faces"] + '/'+faceKey + '?limit=' + limit + '&offset=0' + '&sort=' + sortType;
    try{
      var result = await this.peoplesTabImplementation.getAllPhotosOfSelectedPerson(url);
      return result
    }catch(exc){
      console.log("exception in fetching selected face details",exc);
    }
  }
  

  
  async updateFaceName(faceName, faceKey){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["fgpURL"] + ENV_CONFIG.commonUrls["faceGrouping"] + ENV_CONFIG.commonUrls["faces"] + '/'+faceKey;
    try{
      var result = await this.peoplesTabImplementation.updateFaceName(url,faceName);
      return result;
    }catch(exc){
      console.log("exception in updating name",exc);
      return "error";
    }  
  }

  async enableFaceGroupingToggle(){
    this.peoplesTabImplementation.setHandler(this.globalService);
    //let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["fgpURL"] + ENV_CONFIG.commonUrls["faceGrouping"] + ENV_CONFIG.commonUrls["enableFaceGroupingToggle"];
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"]  + ENV_CONFIG.commonUrls["userFeture"] 
    try{
      var result = await this.peoplesTabImplementation.enableFaceGroupingToggle(url);
      return result
    }catch(exc){
      console.log("exception in fetching selected face details",exc);
      return exc;
    }
  }

  async enablePeopleTabFeature(){
    this.peoplesTabImplementation.setHandler(this.globalService);
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["fgpURL"] + ENV_CONFIG.commonUrls["faceGrouping"] + ENV_CONFIG.commonUrls["enableFaceGrouping"];
    try{
      var result = await this.peoplesTabImplementation.enableFaceGroupingFeature(url);
      await this.userImplRef.getUserDetails();
      let userData = this.localStorageSvc.getUserData(true);
      this.ProfileImplementation.calculateStoragePercentage(userData);
      return result
    }catch(exc){
      console.log("exception in fetching selected face details",exc);
      return exc;
    }
  }

  async getRemoveOptionsList(){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["fgpURL"] +  ENV_CONFIG.commonUrls["faceGrouping"] + ENV_CONFIG.commonUrls["fetchFeedback"];
    try{
      var result = await this.peoplesTabImplementation.getRemoveOptionsList(url);
      return result
    }catch(exc){
      console.log("exception in fetching remove option list",exc);
      return "error";
    }

  }

  async removeResults(ids){
    var faceKey = this.universalService.selectedFace["metadata"]["face_key"];
    var objectKeys = [];
    this.universalService.selectedNodes.map(x=>objectKeys.push(x["object_key"]));
    var params = {
      "face_key": faceKey,
      "feedback_id": ids,
      "object_keys":objectKeys
    }
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["fgpURL"] + ENV_CONFIG.commonUrls["faceGrouping"] + ENV_CONFIG.commonUrls["removeResults"];
    try{
      var result = await this.peoplesTabImplementation.removeResults(url,params);
      return result
    }catch(exc){
      console.log("exception in removing results",exc);
      return "error";
    }
  }

  async setAsCoverPhoto(selectedPhotoObj){
    var faceKey = this.universalService.selectedFace["metadata"]["face_key"];
    var params = {
      "face_key": faceKey,
      "object_key":selectedPhotoObj["objectKey"],
      "file_name": selectedPhotoObj["objectName"],
      "file_type": selectedPhotoObj["mimeSubType"]
    }
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["fgpURL"] + ENV_CONFIG.commonUrls["faceGrouping"] + ENV_CONFIG.commonUrls["faceGroupingSetCoverPic"];
    try{
      var result = await this.peoplesTabImplementation.setAsCoverPhoto(url,params);
      this.universalService.showMobOptionMenu = false;
      this.universalService.mobileSelectionModeOn = false;
      this.listService.deSelectAll();
      this.universalService.disableModalBackdrop();
      return result
    }catch(exc){
      this.universalService.showMobOptionMenu = false;
      this.universalService.mobileSelectionModeOn = false;
      this.listService.deSelectAll();
      this.universalService.disableModalBackdrop();
      console.log("exception in setAsCoverPhoto results",exc);
      return "error";
    }
  }

  async updateUIAfterPerformingAction(list,executedTask){
    var array = [];
    array = this.peoplesTabImplementation.detectedFaces;
    if(executedTask == 'TRASH' || executedTask == "MOVE"){
        this.fileOperationsImplementation.setHandler(this.globalService);
        if(executedTask == 'TRASH'
          || (!this.universalService.showPreview && executedTask == 'MOVE' && this.universalService.currentTab == 'Person Details') ){
          var result = await this.fileOperationsImplementation.updateSummaryCountsAndUI(array,list,executedTask);
          array = result;
          if(result.length == 0){
            if(this.peoplesTabImplementation.peopleNextLink == "") { // If there is no next page data post TRASH, fetch latest face
              AppEvents.emit("FACE_GROUPING_GET_LATEST_FACES_SEARCH");
            }
            this.fetchNextPageData();
          }else{
            this.peoplesTabImplementation.updateDetectedFacesCountOnTheUI(array)
          }
        }else{
          this.listService.deSelectAll(null);
        }
    }else if(executedTask == 'RENAME' || executedTask == 'SETFAV' || executedTask == 'UNSETFAV' || executedTask == "SHAREPERMISSION"){
        this.fileOperationsImplementation.setHandler(this.globalService);
        var result = await this.fileOperationsImplementation.updateOnlyTheUI(array, list,executedTask)
        array = result
    }else{
        console.log("task invalid",executedTask)
    }

    AppEvents.virtualDOMObservable.next({"updateVDOM":true})
  }

  async fetchNextPageData(){
    if(this.universalService.currentTab == "Person Details"){
      this.getAllPhotosOfSelectedPerson(this.universalService.selectedFace["metadata"]["face_key"],this.peoplesTabImplementation.sortType);
    }else if(this.universalService.currentTab == "Place Details"){
      this.getAllPhotosOfSelectedPerson(this.universalService.selectedPlace["objects"]["placeKey"],this.peoplesTabImplementation.sortType);
    }else if(this.universalService.currentTab == "Places"){
      this.getAllDetectedPlaces(this.peoplesTabImplementation.sortType);
    }else if(this.universalService.currentTab == "People"){
      this.getAllDetectedPeoplesFaces();
    }
  }

  clearPreviewCache(){
    this.peoplesTabImplementation.clearPreviewCache();
  }

  //API to get Faces Recommendations
  async getFacesRecommendations() {
    this.peoplesTabImplementation.setHandler(this.globalService);
    var faceMetadata = this.universalService.selectedFace;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["fgpURL"] + ENV_CONFIG.commonUrls["faceGrouping"] + ENV_CONFIG.commonUrls["faceGroupingRecommendation"] + faceMetadata["metadata"]["face_key"];
    try{
      var result = await this.peoplesTabImplementation.getFacesRecommendations(url);
      return result
    }catch(exc){
      console.log("exception in fetching all people details",exc);
      return null
    }
  }

  async mergeRecommendation(suggestionData) {
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["fgpURL"] + ENV_CONFIG.commonUrls["faceGrouping"] + ENV_CONFIG.commonUrls["faceGroupingMergeSuggestions"] ;
    try{
      var result = await this.peoplesTabImplementation.mergeRecommendation(url,suggestionData);
      return result;
    }catch(exc){
      console.log("exception in mergeRecommendation ",exc);
      return "error";
    }
  }

  async getAllDetectedPlaces(sortType){
    this.peoplesTabImplementation.setHandler(this.globalService);
    let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] //* ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
    let url ="";
    if(sortType){
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] + ENV_CONFIG.commonUrls["places"] + "?limit=" + limit + '&sort=' + sortType;
    }else{
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] + ENV_CONFIG.commonUrls["places"] + "?limit=" + limit;
    }
    try{
      var result = await this.peoplesTabImplementation.getAllDetectedPlaces(url);
      return result
    }catch(exc){
      console.log("exception in fetching all people details",exc);
      return null
    }
    
  }
  async getAllPhotosOfSelectedPlace(placeKey,sortType){
    this.peoplesTabImplementation.setHandler(this.globalService);
    let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] + ENV_CONFIG.commonUrls["places"] + ENV_CONFIG.commonUrls["placesObjects"] +placeKey + '&limit=' + limit + '&offset=0' + '&sort=' + sortType;
    try{
      var result = await this.peoplesTabImplementation.getAllPhotosOfSelectedPlace(url);
      return result
    }catch(exc){
      console.log("exception in fetching selected face details",exc);
    }
  }
}